var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPndingAjaxLoad)?_c('div',{staticClass:"p-6 loading-table"},[_c('spinner-color')],1):_c('div',[_c('data-table-client-cost',{attrs:{"data":this.$store.state.dataList.costs,"header":_vm.header,"body":_vm.body,"advancedSearchData":_vm.advancedSearchData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }